import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import XlsxPopulate from "xlsx-populate";
import { saveAs } from "file-saver";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

// helpers
import {
  formateDateApi,
  formateDateandTime,
  formateDate,
  formateDateSemBarra,
} from "helpers/formats";

// services
import { api_POST } from "../../../services/api_service.js";
import { api_GET } from "../../../services/api_service.js";
import { showMessage } from "../../../services/message.js";

//Context
import { useAuth } from "../../../context/auth";

export default function RelatorioFichaRequerimentoGeradores({ handleReturn }) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setValue, clearErrors } = useForm({
    mode: "onBlur",
  });

  const [relatorio, set_relatorio] = useState(null);

  const [lista, set_lista] = useState(Object);

  // Tipo de Requerimento
  const [tipoRequerimento, set_tipoRequerimento] = useState("TODOS");
  const [statusProtocolo, setStatusProtocolo] = useState("TODOS");
  const [subprefeitura, set_Subprefeitura] = useState([]);
  const [categorias, set_categorias] = useState([]);
  const [modalidades, set_modalidades] = useState([]);

  const [options_tipoRequerimento] = useState([
    { value: "TODOS", label: "Todos" },
    { value: "Novo Cadastro", label: "Novo Cadastro" },
    { value: "Renovação", label: "Renovação" },
    { value: "Cancelamento", label: "Cancelamento" },
  ]);
  const [options_statusProtocolo] = useState([
    { value: "TODOS", label: "TODOS" },
    { value: "Ativo", label: "Ativo" },
    { value: "Pendente", label: "Pendente" },
    { value: "Vencido", label: "Vencido" },
    { value: "Inativo", label: "Inativo" },
    { value: "Cancelado", label: "Cancelado" },
  ]);
  const [options_categorias] = useState([
    { value: "RGG", label: "RGG" },
    { value: "RCC", label: "RCC" },
    { value: "RSS", label: "RSS" },
  ]);

  const [options_modalidades, set_OptionsModalidades] = useState([]);
  const [setupSolicitacoes, set_SetupSolicitacoes] = useState([]);

  const handleTipoRequerimento = (value) => {
    set_tipoRequerimento(value);
    setValue("tipoRequerimento", value, true);
    clearErrors("tipoRequerimento");
  };

  const handleTipoProtocolo = (value) => {
    setStatusProtocolo(value);
    setValue("statusProtocolo", value, true);
    clearErrors("statusProtocolo");
  };

  const handleCategorias = (value) => {
    set_categorias(value || []);
    setValue("categorias", value, true);
  };

  const handleModalidades = (value) => {
    set_modalidades(value || []);
    setValue("modalidades", value, true);
  };

  const [options_subprefeitura, set_OptionsSubPrefeitura] = useState([]);
  const [showDetail, set_showDetail] = useState(false);

  const handleSubprefeitura = (value) => {
    set_Subprefeitura(value);
    setValue("subprefeitura", value, true);
  };

  useEffect(() => {
    setValue("tipoRequerimento", tipoRequerimento, true);
  }, []);

  useEffect(() => {
    api_GET("subprefeitura")
      .then((result) => set_OptionsSubPrefeitura(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));

    api_GET("SetupSolicitacao")
      .then((result) =>
        set_SetupSolicitacoes(
          (result.data || []).filter(
            (s) =>
              s.categoria?.segmento === "Grande Gerador" &&
              s.status === "Ativo" &&
              s.deletado !== true
          )
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null));
  }, []);

  // Modalidade filtra pelas Categorias selecionadas (se houver alguma marcada)
  useEffect(() => {
    const siglas = categorias.map((c) => c.value);
    const filtradas =
      siglas.length > 0
        ? setupSolicitacoes.filter((s) => siglas.includes(s.categoria?.sigla))
        : setupSolicitacoes;

    set_OptionsModalidades(
      filtradas.map((s) => ({
        value: s.setupSolicitacao_Id,
        label: s.descricao,
      }))
    );
    // remove seleções de modalidade que não existem mais nas opções filtradas
    set_modalidades((atual) =>
      atual.filter((m) =>
        filtradas.some((s) => s.setupSolicitacao_Id === m.value)
      )
    );
  }, [categorias, setupSolicitacoes]);

  const handleExcel = (data) => {
    set_showDetail(true);
  };

  const [filtro, set_filtro] = useState(null);

  const onSubmit = (data) => {
    const validacaoSubPrefeitura =
      subprefeitura && subprefeitura.length > 0
        ? subprefeitura.map((x) => x.nome)
        : null;

    let json_submit = {
      inicio: formateDateApi(data.dataInicial),
      fim: formateDateApi(data.dataFinal),
      acao: tipoRequerimento,
      statusProtocolo: statusProtocolo,
      subPrefeitura: validacaoSubPrefeitura,
      categorias: categorias.length > 0 ? categorias.map((c) => c.value) : null,
      modalidadesSelecionadas:
        modalidades.length > 0 ? modalidades.map((m) => m.value) : null,
    };

    setLoading(true);
    api_POST("relatorio/RelatorioRequerimentoGeradores", json_submit)
      .then((result) => {
        json_submit.nome = session.nome;
        json_submit.acaoLabel =
          options_tipoRequerimento.find((o) => o.value === tipoRequerimento)
            ?.label ?? tipoRequerimento;
        json_submit.categoriasLabel =
          categorias.length > 0
            ? categorias.map((c) => c.label).join(", ")
            : "Todas";
        json_submit.modalidadesLabel =
          modalidades.length > 0
            ? modalidades.map((m) => m.label).join(", ")
            : "Todas";
        set_filtro(json_submit);
        set_relatorio(result.data);
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (relatorio != null) {
      api_POST("relatorio/ExportToExcelRGG", relatorio.subprefeituras)
        .then((resultExcel) => set_lista(resultExcel.data))
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }
  }, [relatorio]);

  const componentRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });

  //adicionar todas as subprefeituras ao clica no botao
  const handleTakeSubprefeituras = () => {
    set_Subprefeitura(options_subprefeitura);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="6" className="noPrint">
            <Button color="Primary" onClick={handleReturn}>
              <i className="fas fa-chevron-left"></i> Voltar
            </Button>
          </Col>
          {relatorio != null && !showDetail && (
            <Col md="6" className="text-right noPrint">
              <Button color="danger" onClick={handlePrint}>
                <i className="fas fa-print"></i>
              </Button>
            </Col>
          )}
        </Row>
        {relatorio == null && (
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="9">
                      <h4 className="mb-0 mt-0">
                        Requerimento de Geradores
                      </h4>
                      <label className="rel-subtitle">
                        Relatório detalhado de requerimentos de geradores de
                        RGG, RCC e RSS.
                      </label>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="noPrint">
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label">
                            Data Inicial{" "}
                            <label className="text-danger">
                              (Data da última ação - Finalização)
                            </label>
                            :
                          </label>
                          <Input
                            className="form-control"
                            autocomplete="off"
                            type="date"
                            name="dataInicial"
                            innerRef={register({ required: true })}
                          />
                          {errors.dataInicial && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label">
                            Data Final{" "}
                            <label className="text-danger">
                              (Data da última ação - Finalização)
                            </label>
                            :
                          </label>
                          <Input
                            className="form-control"
                            autocomplete="off"
                            type="date"
                            name="dataFinal"
                            innerRef={register({ required: true })}
                          />
                          {errors.dataFinal && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="2" md="2" sm="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Tipo Requerimento:
                          </label>
                          <Select
                            options={options_tipoRequerimento}
                            name="tipoRequerimento"
                            onChange={(e) => {
                              handleTipoRequerimento(e.value);
                            }}
                            value={
                              tipoRequerimento != "" &&
                              options_tipoRequerimento.find(
                                (obj) => obj.value === tipoRequerimento
                              )
                            }
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "tipoRequerimento" },
                                { required: true }
                              )
                            }
                          />
                          {errors.tipoRequerimento && (
                            <span className="form-control-label text-danger">
                              * Campo Obrigatório
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="2" md="2" sm="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Status Protocolo:
                          </label>
                          <Select
                            options={options_statusProtocolo}
                            name="statusProtocolo"
                            onChange={(e) => {
                              handleTipoProtocolo(e.value);
                            }}
                            value={
                              statusProtocolo !== "" &&
                              options_statusProtocolo.find(
                                (obj) => obj.value === statusProtocolo
                              )
                            }
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "statusProtocolo" },
                                { required: false }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Categoria:
                          </label>
                          <Select
                            options={options_categorias}
                            name="categorias"
                            onChange={handleCategorias}
                            value={categorias}
                            placeholder="Todas"
                            isMulti
                            ref={(e) =>
                              register({ name: "categorias" }, { required: false })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="8" md="8" sm="12">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Modalidade:
                          </label>
                          <Select
                            options={options_modalidades}
                            name="modalidades"
                            onChange={handleModalidades}
                            value={modalidades}
                            placeholder="Todas"
                            isMulti
                            ref={(e) =>
                              register({ name: "modalidades" }, { required: false })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col className="col-12">
                        <FormGroup>
                          <label className="form-control-label">
                            Regional / SubPrefeitura:
                          </label>
                          <Select
                            options={options_subprefeitura}
                            getOptionLabel={(option) => option.nome}
                            getOptionValue={(option) => option.subPrefeitura_Id}
                            name="subprefeitura"
                            onChange={(e) => {
                              handleSubprefeitura(e);
                            }}
                            value={subprefeitura}
                            placeholder="Selecione"
                            isMulti
                            ref={(e) =>
                              register(
                                { name: "subprefeitura" },
                                { required: false }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <Button
                          color="sucess"
                          type="button"
                          className="btn btn-link"
                          onClick={handleTakeSubprefeituras}
                        >
                          Selecionar Todos
                        </Button>
                      </Col>
                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="info"
                          className="btn-mobile"
                          type="submit"
                        >
                          {" "}
                          Gerar Relatório
                        </Button>
                      </Col>
                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="danger"
                          className="btn-mobile"
                          type="submit"
                          onClick={() => handleExcel(relatorio)}
                        >
                          {" "}
                          Gerar Excel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {!showDetail && relatorio && (
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <ComponentToPrint
                    relatorio={relatorio}
                    filtro={filtro}
                    ref={componentRef}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {showDetail && relatorio && lista.length > 0 && (
          <Row>
            <Col md="12">
              <ComponentToExcel
                relatorio={lista}
                filtro={filtro}
                ref={componentRef}
              />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;
  const filtro = props.filtro;
  const resumo = relatorio?.resumo;
  const subprefeituras = relatorio?.subprefeituras || [];
  return (
    <div ref={ref}>
      <div className="row">
        <div className="col-9">
          <h4 className="mb-0 mt-0">Requerimento de Geradores</h4>
          <label>
            Relatório detalhado de requerimentos de geradores de RGG, RCC e
            RSS.
          </label>
        </div>
        <div className="col-3 text-right">
          <label>Gerado em {formateDateandTime(new Date())}</label>
        </div>
      </div>
      {filtro != null && (
        <div className="row rel-filter">
          <div className="col-4">
            <span>
              <b>Período</b>
            </span>
            <br />
            <span>
              {formateDate(filtro.inicio) + " a " + formateDate(filtro.fim)}
            </span>
          </div>
          <div className="col-4">
            <span>
              <b>Gerado Por</b>
            </span>
            <br />
            <span>{filtro.nome}</span>
          </div>
          <div className="col-4">
            <span>
              <b>Tipo Requerimento</b>
            </span>
            <br />
            <span>{filtro.acaoLabel ?? filtro.acao}</span>
          </div>
          <div className="col-4">
            <span>
              <b>Status Protocolo</b>
            </span>
            <br />
            <span>{filtro.statusProtocolo}</span>
          </div>
          <div className="col-4">
            <span>
              <b>Categoria</b>
            </span>
            <br />
            <span>{filtro.categoriasLabel}</span>
          </div>
          <div className="col-4">
            <span>
              <b>Modalidade</b>
            </span>
            <br />
            <span>{filtro.modalidadesLabel}</span>
          </div>
        </div>
      )}
      {resumo != null && (
        <div
          className="row justify-content-center"
          style={{ margin: "24px 0" }}
        >
          {[
            {
              label: "Novos Cadastros",
              value: resumo.novosCadastros,
              color: "#2dce89",
              icon: "fa-user-plus",
            },
            {
              label: "Cancelamentos",
              value: resumo.cancelamentos,
              color: "#fb6340",
              icon: "fa-times-circle",
            },
            {
              label: "Renovações",
              value: resumo.renovacoes,
              color: "#11cdef",
              icon: "fa-sync-alt",
            },
          ].map((stat, key) => (
            <div className="col-auto" key={key} style={{ padding: "0 12px" }}>
              <div
                style={{
                  minWidth: 220,
                  borderRadius: 16,
                  background: "#fff",
                  boxShadow:
                    "0 0.5rem 1.5rem rgba(34, 41, 47, 0.1), 0 0 1px rgba(34, 41, 47, 0.08)",
                  padding: "24px 28px",
                  display: "flex",
                  alignItems: "center",
                  gap: 18,
                }}
              >
                <div
                  style={{
                    width: 52,
                    height: 52,
                    borderRadius: "50%",
                    background: stat.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    boxShadow: `0 4px 12px ${stat.color}66`,
                  }}
                >
                  <i
                    className={`fas ${stat.icon}`}
                    style={{ color: "#fff", fontSize: 20 }}
                  ></i>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 600,
                      color: "#8898aa",
                      textTransform: "uppercase",
                      letterSpacing: 0.4,
                    }}
                  >
                    {stat.label}
                  </div>
                  <div
                    style={{ fontSize: 28, fontWeight: 700, color: "#32325d" }}
                  >
                    {stat.value}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {subprefeituras.map((m, key) => (
        <div key={key}>
          <h5>
            <strong>{m.geradores.length > 0 ? m.subprefeitura : ""}</strong>
          </h5>
          {m.geradores.map((n, key2) => (
            <div className="rel-group" key={key2}>
              <div className="row rel-item">
                <div className="col-6">
                  <span>
                    <b>Categoria: </b>
                  </span>
                  <span>{n?.categoria}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Modalidade: </b>
                  </span>
                  <span>{n?.modalidade}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Tipo de Cadastro: </b>
                  </span>
                  <span>{n?.tipoCadastro}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Situação: </b>
                  </span>
                  <span>{n?.situacao}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Regional/SubPrefeitura: </b>
                  </span>
                  <span>{" " + m.subprefeitura}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Código: </b>
                  </span>
                  <span>{" " + n.codigo}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Razão Social: </b>
                  </span>
                  <span>{" " + n.razaoSocial}</span>
                </div>
                <div className="col-3">
                  <span>
                    <b>CNPJ: </b>
                  </span>
                  <span>{" " + n.cnpj}</span>
                </div>
                <div className="col-3">
                  <span>
                    <b>CEP: </b>
                  </span>
                  <span>{" " + n.cep}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Logradouro: </b>
                  </span>
                  <span>{" " + n.logradouro}</span>
                </div>
                <div className="col-3">
                  <span>
                    <b>Nº: </b>
                  </span>
                  <span>{" " + n.numero}</span>
                </div>
                <div className="col-3">
                  <span>
                    <b>Complemento: </b>
                  </span>
                  <span>{" " + n.complemento}</span>
                </div>
                <div className="col-6">
                  <span>
                    <b>Bairro: </b>
                  </span>
                  <span>{" " + n.bairro}</span>
                </div>
                <div className="col-12">
                  <span>
                    <b>Locais de Coleta: </b>
                  </span>
                </div>
                {n?.locaisColeta?.map((l, key3) => (
                  <div className="col-12" key={key3}>
                    <span>
                      {" " +
                        l.logradouro +
                        ", " +
                        l.numero +
                        ", " +
                        l.complemento +
                        " - " +
                        l.bairro}
                      {l.transportador && " — Transportador (TR): " + l.transportador}
                      {l.modalidadeColeta && " (" + l.modalidadeColeta + ")"}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
});

export const ComponentToExcel = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;
  const filtro = props.filtro;

  const campos = [
    "subprefeitura",
    "codigo",
    "razaoSocial",
    "cnpj",
    "cep",
    "logradouro",
    "numero",
    "complemento",
    "bairro",
    "categoria",
    "modalidade",
    "tipoCadastro",
    "situacao",
    "transportador",
    "dataInclusao",
  ];

  const header = [
    "SubPrefeitura",
    "Código",
    "Razão Social",
    "CNPJ",
    "CEP",
    "Logradouro",
    "Nº",
    "Complemento",
    "Bairro",
    "Categoria",
    "Modalidade",
    "Tipo de Cadastro",
    "Situação",
    "Transportador",
    "Data Inclusão",
  ];

  function getSheetData(data) {
    var sheetData = data.map(function (row) {
      return campos.map(function (campo) {
        if (campo === "dataInclusao")
          return row[campo] ? formateDateSemBarra(row[campo]) : "";
        return row[campo] != null ? row[campo] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  async function saveAsExcel() {
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const dia = new Date();
      const sheet1 = workbook.sheet(0).name("Geradores");
      const sheetData = getSheetData(relatorio);
      const totalColumns = sheetData[0].length;

      sheet1.cell("A1").value(sheetData);
      const range = sheet1.usedRange();
      const endColumn = String.fromCharCode(64 + totalColumns);
      sheet1.row(1).style("bold", true);
      sheet1.range("A1:" + endColumn + "1");
      return workbook.outputAsync().then((res) => {
        saveAs(
          res,
          "RelatorioRequerimentoGeradores_" +
          dia.getDate() +
          (dia.getMonth() + 1) +
          dia.getFullYear() +
          ".xlsx"
        );
      });
    });
  }

  return (
    <>
      <Col md="12" className="text-right noPrint">
        <Button className="btn btn-info" onClick={saveAsExcel}>
          Exportar como XLS
        </Button>
      </Col>
      <Card className="card-stats">
        <CardBody>
          <div class="table-responsive">
            <table id="RGG_Excel" class="table">
              <thead>
                <tr>
                  {header.map((h, key) => (
                    <th key={key}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {relatorio.map((item, key) => (
                  <tr key={key}>
                    <td>{item.subprefeitura}</td>
                    <td>{item.codigo}</td>
                    <td>{item.razaoSocial}</td>
                    <td>{item.cnpj}</td>
                    <td>{item.cep}</td>
                    <td>{item.logradouro}</td>
                    <td>{item.numero}</td>
                    <td>{item.complemento}</td>
                    <td>{item.bairro}</td>
                    <td>{item.categoria}</td>
                    <td>{item.modalidade}</td>
                    <td>{item.tipoCadastro}</td>
                    <td>{item.situacao}</td>
                    <td>{item.transportador}</td>
                    <td>
                      {item.dataInclusao
                        ? formateDate(item.dataInclusao)
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </>
  );
});
